import React from 'react';
import Link from 'next/link';
import { isSsrPath } from '@sy/ssr-routing';

const SsrLink = ({ children, href, ...props }: Props) => {
	const isValidSsrPath = isSsrPath(href.toString());

	if (isValidSsrPath) {
		return (
			<Link href={href} {...props}>
				{children}
			</Link>
		);
	}

	if (typeof children === 'string') {
		return (
			<a data-testid="regular-link" href={href.toString()} {...props}>
				{children}
			</a>
		);
	}

	return React.cloneElement(children, {
		href: href.toString(),
		...props,
	});
};

type Props = Omit<React.ComponentProps<typeof Link>, 'children'> & {
	children: React.ReactElement | string;
};

export default SsrLink;
